import { __makeTemplateObject } from '../../../_virtual/_tslib.js';
import { Icon } from '@fluentui/react';
import styled from 'styled-components/macro';

var StIcon = styled(Icon)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-right: var(--space-xxxs);\n    /* color: var(--color-contrast-medium); */\n"], ["\n    margin-right: var(--space-xxxs);\n    /* color: var(--color-contrast-medium); */\n"])));
var templateObject_1;

export { StIcon };
